module.exports = __webpack_public_path__ + "assets/a61f50f23da158a0d0b88a25a1f8f123.svg";